import React, { useEffect, useState } from 'react';
import Loading from '../../../../../components/common/Loading';
import { Bar } from 'react-chartjs-2';
import ORBApi from '../../../../../services/ORBApi';
import { GraphColors } from './GraphOptions';

const WorksContributorRevenueGraph = ({ filters, currency }) => {
	const [contributor, setContributor] = useState([]);
	const [valueContributor, setValueContributor] = useState([]);
	const [fileProcessing, setFileProcessing] = useState(0);
	const [requestSource, setRequestSource] = useState(null);

	const doSearch = () => {
		if (fileProcessing) {
			// if there is a request processing, cancel it
			ORBApi.abortRequest(requestSource);
		}
		setFileProcessing(1);
		// Get the request abort source, to be used to cancel the request if needed
		var cancelRequestSource = ORBApi.getRequestAbortSource();
		setRequestSource(cancelRequestSource);
		ORBApi.loadWorksContributorsRevenue(
			filters.startDate,
			filters.endDate,
			filters.dateType,
			filters.workId,
			filters.contributorId,
			filters.publisher
		)
			.then((data) => {
				if (!data || !data.contributors) {
					setContributor([]);
					setValueContributor([]);
					setFileProcessing(0);
					return;
				}
				setContributor(data.contributors.map((i) => i?.contributor || 'N/A'));
				setValueContributor(data.contributors.map((i) => i?.value || 0));
				setFileProcessing(0);
			})
			.catch((error) => {
				if (!ORBApi.isCancel(error)) {
					// When cancelling the request, do not remove the "loading"
					setFileProcessing(0);
				}
			});
	};

	useEffect(() => {
		doSearch();
	}, [filters]);

	return (
		<div>
			{fileProcessing ? (
				<Loading className='file-loading-container' />
			) : contributor.length === 0 ? (
				<div style={{ textAlign: 'center', padding: '20px' }}>
					Sem dados para exibir
				</div>
			) : (
				<Bar
					data={{
						labels: contributor,
						datasets: [
							{
								data: valueContributor,
								backgroundColor: GraphColors,
							},
						],
					}}
					options={{
						plugins: {
							legend: {
								display: false,
							},
							tooltip: {
								callbacks: {
									label: function (context) {
										return context.parsed.y.toLocaleString(
											'pt-br',
											{
												style: 'currency',
												currency: currency,
											}
										);
									},
								},
							},
						},
						scales: {
							y: {
								beginAtZero: true,
								ticks: {
									callback: function (
										value,
										index,
										values
									) {
										return value.toLocaleString(
											'pt-br',
											{
												style: 'currency',
												currency: currency,
											}
										);
									},
								},
							},
						},
					}}
				/>
			)}
		</div>
	);
};

export default WorksContributorRevenueGraph;
